import styles from "./Designer.module.scss";
import BaseModal from "./BaseModal";
import HingeDoor from "../../assets/images/modal_hinge_door.png"
import SlidingDoor from "../../assets/images/modal_sliding_door.png"
import React from "react";

interface Props {
  open: boolean,
  onClose: () => void,
}

function DoorInfoModal({ open, onClose }: Props) {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className={styles.Modal}>
        <div className={styles.ModalTitle}>门型说明</div>
        <div className={styles.ModalDoorImage}>
          <img src={HingeDoor} alt={'door'}/>
        </div>
        <div className={styles.ModalSubTitle}>【合页门】可以打开全部衣柜空间，方便 取物。防尘除灰。复古百搭。</div>
        <div className={styles.ModalDoorImage}>
          <img src={SlidingDoor} alt={'door'}/>
        </div>
        <div className={styles.ModalSubTitle}>【滑门】无需占用开门空间，适合衣柜过道 较窄的卧室。防尘除灰，较为现代。</div>
        <div className={styles.ModalConfirmBtn} onClick={onClose}>我知道了</div>
      </div>
    </BaseModal>)
}

export default DoorInfoModal;
